import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Books from './pages/Books';
import BookDetail from './pages/BookDetail';
import Poems from './pages/Poems';
import Stories from './pages/Stories';
import Login from './pages/Login';
import Forum from './pages/Forum';
import ForumThread from './pages/ForumThread';
import Reader from './pages/reader/Reader';
import Dashboard from './pages/admin/Dashboard';
import './styles/globals.css';

const AppRoutes: React.FC = () => {
  const location = useLocation();
  const isReaderPage = location.pathname.startsWith('/read/');
  const isDashboardPage = location.pathname.startsWith('/dashboard');

  return (
    <>
      {!isReaderPage && <Navbar />}
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/books" element={<Books />} />
          <Route path="/books/:id" element={<BookDetail />} />
          <Route path="/poems" element={<Poems />} />
          <Route path="/stories" element={<Stories />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forum" element={<Forum />} />
          <Route path="/forum/:id" element={<ForumThread />} />
          <Route path="/read/book/:bookId/chapter/:chapterId" element={<Reader />} />
          <Route path="/dashboard" element={<Dashboard />} />
        </Routes>
      </AnimatePresence>
      {!isReaderPage && !isDashboardPage && <Footer />}
    </>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </Router>
  );
}

export default App;
